var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 341",
    width: 340,
    height: 341,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #555555;stroke-width: 14.618 } \n\t\t.shp1 { fill: #555555 } \n\t\t.shp2 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M170 332.94C80.03 332.94 7.31 260.22 7.31 170.25C7.31 80.28 80.03 7.56 170 7.56C259.97 7.56 332.69 80.28 332.69 170.25C332.69 260.22 259.97 332.94 170 332.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp1",
    d: "M75.66 95.06L264.34 95.06C271.08 95.06 276.61 100.6 276.61 107.34L276.61 217.79C276.61 224.53 271.08 230.06 264.34 230.06L75.66 230.06C68.92 230.06 63.39 224.53 63.39 217.79L63.39 107.34C63.39 100.6 68.92 95.06 75.66 95.06ZM75.66 102.08C72.69 102.08 70.42 104.37 70.42 107.34L70.42 217.79C70.42 220.76 72.69 223.03 75.66 223.03L264.34 223.03C267.31 223.03 269.58 220.76 269.58 217.79L269.58 107.34C269.58 104.37 267.31 102.08 264.34 102.08L75.66 102.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M52.15 232.09C52.15 239.51 57.28 245.48 63.64 245.48L276.36 245.48C282.72 245.48 287.85 239.51 287.85 232.09L52.15 232.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp2",
    d: "M152.45 234.9L187.55 234.9C188.1 234.9 188.53 235.34 188.53 235.88C188.53 236.42 188.1 236.86 187.55 236.86L152.45 236.86C151.91 236.86 151.48 236.42 151.48 235.88C151.48 235.34 151.91 234.9 152.45 234.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.d8271f81fc6664b2ff5155603db41d5a.svg";
export { ForwardRef as ReactComponent };